// Intelligems Quantity Event Listeners
function initialLoad() {
    const addButton = document.querySelector('.quantity-wrapper a[data-quantity="up"]');
    const removeButton = document.querySelector('.quantity-wrapper a[data-quantity="down"]');
    
    function igCallback(){
      setTimeout(() => {
        const quantityField = document.querySelector("#quantity")
      
        if (quantityField && window.igData && window.igData.price && window.igData.price.updateQuantity){
          igData.price.updateQuantity(quantityField.value)
        }
      }, 200)
    }

    if (addButton){
      addButton.addEventListener("click", function(event){
        igCallback()
      })
    }

    if (removeButton){
      removeButton.addEventListener("click", function(event){
        igCallback()
      })
    }
  }

  if (document.readyState === "complete") {
    initialLoad();
  } else {
    window.addEventListener("load", initialLoad);
  }